"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../../../ControlRendererContext"));
const wrapper = {
    position: 'absolute',
    bottom: 10,
};
const containerFlex = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
};
const Points = ({ size, currentIndex, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const styleCircle = (0, react_1.useMemo)(() => ({
        margin: 5,
        backgroundColor: 'white',
        width: 10,
        height: 10,
        borderRadius: 50,
    }), []);
    return (react_1.default.createElement(Render.View, { style: wrapper },
        react_1.default.createElement(Render.View, { style: containerFlex }, (new Array(size)).fill(9).map((_, index) => (react_1.default.createElement(Render.View
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: index, style: Object.assign(Object.assign({}, styleCircle), { opacity: currentIndex === index ? 1 : 0.6 }) }))))));
};
exports.default = Points;
